import { createElement, type HTMLAttributes, type ReactElement, type ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Title.module.css';

const TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

export type TitleProps = HTMLAttributes<HTMLHeadingElement> & {
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  fz?: string;
  fw?: 400 | 500 | 600 | 700 | 800;
  children: ReactNode;
};

export function Title({ order = 1, fz, fw = 500, className, style, children, ...rest }: TitleProps): ReactElement {
  const tag = TAGS[Math.min(6, Math.max(1, order)) - 1];
  return createElement(tag, {
    className: cx(styles.title, className),
    'data-order': String(order),
    style: { fontSize: fz, fontWeight: fw, ...style },
    ...rest,
    children,
  });
}
